<script>
import { authComputed } from '@state/helpers';
import ProspectCampaignStatusIndicatorItem from './prospect-campaign-status-indicator-item.vue';

export default {
  components: {
    ProspectCampaignStatusIndicatorItem,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...authComputed,
  },
  methods: {
    isConverted(campaign) {
      return (
        this.prospect?.is_converted && campaign.order === this.campaigns.length
      );
    },
  },
};
</script>

<template>
  <ul class="campign-progress-list">
    <li
      class="campign-progress-item"
      v-for="(campaign, i) in campaigns"
      :key="i"
    >
      <ProspectCampaignStatusIndicatorItem
        :prospect="prospect"
        :campaign="campaign"
        :campaignNum="campaign.order"
        :isConverted="isConverted(campaign)"
      />
      <span
        class="progress-item-divider"
        v-if="campaign.order < campaigns.length || isConverted(campaign)"
      />
      <ProspectCampaignStatusIndicatorItem
        :prospect="prospect"
        :campaign="campaign"
        :isConverted="isConverted(campaign)"
        v-if="isConverted(campaign)"
      />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.campign-progress-list {
  flex: 1;
  margin-bottom: 0;
}

.campign-progress-item {
  align-items: center;
  display: inline-flex;

  .progress-item-divider {
    background-color: $color-primary;
    height: 0.1rem;
    margin: 0 0.4rem;
    width: 1.2rem;
  }
}
</style>
